import type { QueryKey } from '@tanstack/react-query';
import type { GetAllBannerSetsQueryParams } from '.';

export const get_all_banner_sets_query_key = ({ active, id, name, page = 1, pageUrl, quantity = 5, routeId }: GetAllBannerSetsQueryParams): QueryKey => [
	'get-all-banner-sets',
	active,
	id,
	name,
	page,
	pageUrl,
	quantity,
	routeId,
];
